// export const environment = {
//   production: true
// };

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyD7boGDgyqUh6Aggip6F2LbBTYy6OKaRHY",
    projectId: "edutin-push-notifications",
    messagingSenderId: "419389701075",
    appId: "1:419389701075:web:07dda7268f53bf87be8d26"
  },
  firebaseTest: {
    apiKey: "AIzaSyAh77vK1e1xocAZt4nusOWYkSA0P4g9b64",
    authDomain: "pushnotification-c9ca1.firebaseapp.com",
    projectId: "pushnotification-c9ca1",
    storageBucket: "pushnotification-c9ca1.appspot.com",
    messagingSenderId: "348342166350",
    appId: "1:348342166350:web:752d96acfb70869a99741f"
  },
  apiEndpoint: 'https://api.kc.edutin.com/b/d',
  keyApi: 'https://kyclk.edutin.com/realms/edutin',
  // keyApi: 'https://ojfek9m8wy0tl6p2v6sbgzglke2mks9.edutin.com/realms/edutin',\
  locationEndPoint: 'https://d2qff10pjfk7uz.cloudfront.net/b/d/users/location',
  businessApiEndpoint: 'https://api.edutin.com/bus/d',
  urlFormsApi: 'https://api.edutin.com/fm/d',
  urlCvApi: 'https://api.edutin.com/cv/p',
  domain: 'https://7428c012-617a-4a8e-8f03-43e12a0d40de.edutin.com',
  urlAdDomain: 'https://aviewerdev.edutin.com',
  appDomain: 'https://ruy407jd.accounts.edutin.com',
  appAccountDomain: 'https://ruy407jd.accounts.edutin.com',
  redirectSignIn: "https://06de1684-edc7-4172-947e-45f6d1146fb4.edutin.com/home/",
  redirectSignOut: "ruy407jd.accounts.edutin.com/accounts",
  recaptchaSiteKey: '6LcqB9AoAAAAAPEzmDtU8hluhvTTebsi8R6q-4HK',

  //redirects Apps
  mainApp: 'https://06de1684-edc7-4172-947e-45f6d1146fb4.edutin.com',
  // mainApp: 'http://127.0.0.1:8100',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
